// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-module__listBox--_k4pU {
    display: flex;
    flex-direction: column;
    gap: 5px;
    border-radius: 14px;
    margin-top: 30px;
    margin-bottom: 30px;
    width: 100%;
    overflow: hidden; 
}

.list-module__tableWrapper--dVmRo {
    width: 100%;
    overflow-x: auto; 
    overflow-y: hidden; 
    -webkit-overflow-scrolling: touch;
}

.list-module__scrollableTable--YqeuB {
    min-width: max-content;
    width: 100%;
}
  .list-module__tableRow--EXmP8 {
    position: relative;
}
  .list-module__tableRow--EXmP8::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: -1;
    width: var(--table-width, 100%);
}

  .list-module__boxContentItemHeader--RxX74, .list-module__boxContentItem--JT4gQ > a, .list-module__boxContentItem--JT4gQ > div {
    display: flex;
    width: fit-content;
    min-width: 100%;
    height: 60px;
  }
  
  .list-module__boxContentItemHeader--RxX74 > div, 
  .list-module__boxContentItem--JT4gQ > a > div, 
  .list-module__boxContentItem--JT4gQ > div > div {
    flex: 1;
    min-width: 170px;
    text-align: center;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .list-module__boxContentItem--JT4gQ > a > div, 
  .list-module__boxContentItem--JT4gQ > div > div {
    color: #6F879C;
  }

  .list-module__boxContentItem--JT4gQ > a > div > p, 
  .list-module__boxContentItem--JT4gQ > div > div > p {
    display: flex;
    align-items: center;
    justify-content: center;
}
  
  .list-module__boxContentItemHeader--RxX74 {
    border: 1px solid #eee;
    color: #6F879C;
    font-weight: 500;
    padding: 0;
    background-color: #E7EAF0;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    border-bottom: none;
  }
  
  .list-module__boxContentItem--JT4gQ {
    border: 1px solid #eee;
    padding: 0;
    background-color: white;
    height: 60px;
    border-bottom: none;
  }
  
  .list-module__tableRowLink--m2IJf {
    text-decoration: none;
    color: inherit;
  }
  
  .list-module__tableRowLink--m2IJf:hover {
    background-color: #f5f5f5;
  }
  
  .list-module__btnBox--GoGoS {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }`, "",{"version":3,"sources":["webpack://./src/widgets/list/list.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;EACE;IACE,kBAAkB;AACtB;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,uBAAuB;IACvB,WAAW;IACX,+BAA+B;AACnC;;EAEE;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;EAEA;;;IAGE,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;EAEE;IACE,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX","sourcesContent":[".listBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 5px;\r\n    border-radius: 14px;\r\n    margin-top: 30px;\r\n    margin-bottom: 30px;\r\n    width: 100%;\r\n    overflow: hidden; \r\n}\r\n\r\n.tableWrapper {\r\n    width: 100%;\r\n    overflow-x: auto; \r\n    overflow-y: hidden; \r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.scrollableTable {\r\n    min-width: max-content;\r\n    width: 100%;\r\n}\r\n  .tableRow {\r\n    position: relative;\r\n}\r\n  .tableRow::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    background-color: white;\r\n    z-index: -1;\r\n    width: var(--table-width, 100%);\r\n}\r\n\r\n  .boxContentItemHeader, .boxContentItem > a, .boxContentItem > div {\r\n    display: flex;\r\n    width: fit-content;\r\n    min-width: 100%;\r\n    height: 60px;\r\n  }\r\n  \r\n  .boxContentItemHeader > div, \r\n  .boxContentItem > a > div, \r\n  .boxContentItem > div > div {\r\n    flex: 1;\r\n    min-width: 170px;\r\n    text-align: center;\r\n    font-size: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .boxContentItem > a > div, \r\n  .boxContentItem > div > div {\r\n    color: #6F879C;\r\n  }\r\n\r\n  .boxContentItem > a > div > p, \r\n  .boxContentItem > div > div > p {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n  \r\n  .boxContentItemHeader {\r\n    border: 1px solid #eee;\r\n    color: #6F879C;\r\n    font-weight: 500;\r\n    padding: 0;\r\n    background-color: #E7EAF0;\r\n    border-top-left-radius: 14px;\r\n    border-top-right-radius: 14px;\r\n    border-bottom: none;\r\n  }\r\n  \r\n  .boxContentItem {\r\n    border: 1px solid #eee;\r\n    padding: 0;\r\n    background-color: white;\r\n    height: 60px;\r\n    border-bottom: none;\r\n  }\r\n  \r\n  .tableRowLink {\r\n    text-decoration: none;\r\n    color: inherit;\r\n  }\r\n  \r\n  .tableRowLink:hover {\r\n    background-color: #f5f5f5;\r\n  }\r\n  \r\n  .btnBox {\r\n    margin-top: 30px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 20px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listBox": `list-module__listBox--_k4pU`,
	"tableWrapper": `list-module__tableWrapper--dVmRo`,
	"scrollableTable": `list-module__scrollableTable--YqeuB`,
	"tableRow": `list-module__tableRow--EXmP8`,
	"boxContentItemHeader": `list-module__boxContentItemHeader--RxX74`,
	"boxContentItem": `list-module__boxContentItem--JT4gQ`,
	"tableRowLink": `list-module__tableRowLink--m2IJf`,
	"btnBox": `list-module__btnBox--GoGoS`
};
export default ___CSS_LOADER_EXPORT___;
